import React, { useCallback, useEffect, useState } from 'react'
import HOC from '../../components/HOC/HOC'
import { Link, useNavigate } from 'react-router-dom';
import endPoints from '../../Repository/apiConfig';
import { deleteApi, getApi } from '../../Repository/Api';


import { LuEye } from "react-icons/lu";

import img from '../../assest/loading1.gif'
import { DeleteConfirmation, ViewDescription } from '../../components/Modals/Modals';

import { FaEdit } from "react-icons/fa";
import { MdDelete } from "react-icons/md";



const MonthlySubscription = () => {
    const navigate = useNavigate()
    const [subscriptionData, setSubscriptionData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [selectedItem, setSelectedItem] = useState(null);

    const [itemToDelete, setItemToDelete] = useState(null);
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [deleteLoading, setDeleteLoading] = useState(false);



    const fetchData = useCallback(async () => {
        await getApi(endPoints.getallSubscription, {
            setResponse: setSubscriptionData,
            setLoading: setLoading,
            errorMsg: "Failed to fetch subscription data!",
        })
    }, []);

    useEffect(() => {
        fetchData();
    }, [fetchData]);


    const handleDeleteClick = (categoryId) => {
        setItemToDelete(categoryId);
        setShowDeleteModal(true);
    };

    const confirmDelete = async () => {
        if (!itemToDelete) return;
        await deleteApi(endPoints.deleteplan(itemToDelete), {
            setLoading: setDeleteLoading,
            successMsg: "Plan deleted successfully!",
            errorMsg: "Failed to delete plan!",
        });
        fetchData();
        setShowDeleteModal(false);
       
    };

    const openDescriptionModal = (data) => {
        setSelectedItem(data);
        setShowModal(true)
    };





    const truncateText = (htmlString, maxLength) => {
        const tempElement = document.createElement("div");
        tempElement.innerHTML = htmlString;
        const textContent = tempElement.textContent || tempElement.innerText || "";

        return textContent.length > maxLength ? `${textContent.slice(0, maxLength)}...` : textContent;
    };




    return (
        <>
            <ViewDescription
                show={showModal}
                onHide={() => setShowModal(false)}
                data={selectedItem}
            />
            <DeleteConfirmation
                show={showDeleteModal}
                onHide={() => setShowDeleteModal(false)}
                onConfirm={confirmDelete}
                loading={deleteLoading}
            />
            <div className='userlistcontainer'>
                <div className='userlist1'>
                    <div className='userlist2'>
                        <h6>Monthly Subscription</h6>
                    </div>
                    <div className='userlist3'>
                        <div className='userlist5'>
                            <button onClick={() => navigate('/monthlysubscription/add-plan')}>Add Plan</button>
                        </div>
                    </div>
                </div>
                <div className='userlist6'>
                    <div className='bottomdashboard3'>
                        <table>
                            <thead>
                                <tr>
                                    <th>Subscription Plan</th>
                                    <th>Price</th>
                                    <th>Plan Benefits</th>
                                    <th>Plan  Duration</th>
                                    <th>Total Subscribed</th>
                                    <th>View list</th>
                                    <th>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {loading ? (
                                    <tr>
                                        <td colSpan="8" className="tableloading">
                                            <img src={img} alt="" />
                                        </td>
                                    </tr>
                                ) : subscriptionData?.data?.length === 0 ? (
                                    <tr>
                                        <td colSpan="8" className="tableloading">
                                            <p>No data available.</p>
                                        </td>
                                    </tr>
                                ) : (
                                    subscriptionData?.data?.map((subscription, index) => (
                                        <tr key={index}>
                                            <td>{subscription.name}</td>
                                            <td>{subscription.price.toFixed(2)}</td>
                                            <td>
                                                <span dangerouslySetInnerHTML={{ __html: truncateText(subscription?.description, 15) }} />{' '}
                                                {subscription?.description?.replace(/<\/?[^>]+(>|$)/g, "").length > 15 && (
                                                    <button
                                                        onClick={() => openDescriptionModal(subscription?.description)}
                                                        style={{
                                                            color: 'blue',
                                                            textDecoration: 'underline',
                                                            background: 'none',
                                                            border: 'none',
                                                            cursor: 'pointer',
                                                            padding: 0,
                                                        }}
                                                    >
                                                        Show More
                                                    </button>
                                                )}
                                            </td>
                                            <td>{subscription.type}</td>
                                            <td>{subscription.userCount}</td>
                                            <td>
                                                <Link to={`/monthlysubscription/plan-details/${subscription?._id}`} className="link">
                                                    <LuEye
                                                        color="#000000"
                                                        size={20}
                                                        style={{ cursor: "pointer" }}
                                                    />
                                                </Link>
                                            </td>
                                            <td className='div-icons'>
                                                <Link to={`/monthlysubscription/edit-plan/${subscription?._id}`}>
                                                    <FaEdit />
                                                </Link>
                                                <MdDelete onClick={() => handleDeleteClick(subscription?._id)} />
                                            </td>
                                        </tr>
                                    ))
                                )}
                            </tbody>

                        </table>
                    </div>
                </div>

            </div >
        </>
    )
}

export default HOC(MonthlySubscription)